import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

import Button from './Buttons/Button';

const ErrorStateWithReload = ({
  message = 'An error occurred!',
  buttonText = 'Refresh Page',
  hideButton,
  style,
  className,
  onRefresh,
}) => {
  const handleClick = () => {
    if (onRefresh) onRefresh();
    else window.location.reload();
  };

  return (
    <div className={cx('text-center m-x-auto py-xs', className)} style={style}>
      <p className="m-b text-sm text-bold">
        {message}
      </p>
      {!hideButton && (
        <Button
          size="lg"
          onClick={handleClick}
        >
          {buttonText}
        </Button>
      )}
    </div>
  );
};

ErrorStateWithReload.propTypes = {
  message: T.node,
  buttonText: T.string,
  hideButton: T.bool,
  style: T.object,
  className: T.string,
  onRefresh: T.func,
};

export default ErrorStateWithReload;
